import React from 'react';

export const ScaleGrowthSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={607}
    height={328}
    viewBox="0 0 607 328"
    fill="none"
    {...props}
  >
    <g className="scale-growth-svg-group">
      <g opacity={0.7} filter="url(#filter0_d_1015_1795)">
        <path
          d="M487.219 66.25C516.46 66.2504 540.165 109.852 540.165 163.638C540.165 217.423 516.46 261.025 487.219 261.025C486.346 261.025 485.477 260.984 484.614 260.907V261.025L483.755 260.818C481.421 260.541 479.128 259.985 476.886 259.169L66.25 160.573L477.806 67.7842C479.714 67.1542 481.659 66.7135 483.633 66.4707L484.614 66.25V66.3662C485.477 66.2893 486.346 66.25 487.219 66.25Z"
          fill="url(#paint0_linear_1015_1795)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_1015_1795"
        x={0}
        y={0}
        width={606.415}
        height={327.275}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={33.125} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1015_1795"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1015_1795"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1015_1795"
        x1={511.834}
        y1={104.727}
        x2={357.905}
        y2={303.403}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A7FFDA" />
        <stop offset={1} stopColor="#C5EBFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default ScaleGrowthSvg;